import { Component, EventEmitter, Input, OnInit, Output,ChangeDetectorRef, ViewChild, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { CommonService, ModalWrapperService, PatPreDrugModalService, RxTransferService } from 'src/app/services';
import { CommonUtil } from 'src/app/utils';
import { FormatsUtil } from 'src/app/utils/formats.util';

@Component({
  selector: 'app-transfer-type',
  templateUrl: './transfer-type.component.html',
  styleUrls: ['./transfer-type.component.scss'],
  standalone: false
})
export class TransferTypeComponent implements OnInit {
 selectedDeatils: any;
 @Output()
 SelectedTransType = new EventEmitter<string>();
 @Output()
 SelectedDrugDetails = new EventEmitter<string>();
  @Output() ReSelectPatient = new EventEmitter<string>();
  @Output() SetTransferType = new EventEmitter<string>();
  
 @Input() IsHistory:boolean;
 eRxModelFormG: FormGroup;
 @Input() eRxModelFG: FormGroup;
 @Input() IsfrmPatHis:boolean;
 @Input() RxType:boolean;
 @Input() RequestedInfo;
 @Input() IsTransferType;
 @Input() IsFromProcess;
 @Input() PatientNotFound;
 @Input() DefaultTransferType;
 @Input() IsPush;
 @Input() IsFromXfroutInfo;
 @Input() CurrentDetails;
 @Input() IsFromPatientHistory: boolean;
 
warningMessageForTrans: any = [];
transferInRxs: any = [];
transferInRxsList: any = [];
warningMsgforTransfer: string = "";
notTransferInRxs: any = [];
transferInRxsCopy: any = [];
transferInRxsDisplay: any = [];
previousPatientId: any;

  @Input()
  set PatientInfo(patInfo : any){
     this.getPatientInformation(patInfo);
  }

    @Input() set TransferRxsLists(rxs : any){
        this.transferInRxsCopy = rxs;
    }



 isInputFocused = true;
 eRxPatient: any;
 transferRxInfo = [];
 transferRxInCopy = [];
 selectedRxs = [];
 modalRef2: any;
  unsubscribe$: Subject<void> = new Subject();

   @Output() TransferRxsList = new EventEmitter<any>();

  @ViewChild("SelectRxsFromPatHistory", { static: true })
  SelectRxsFromPatHistory: any;
  private _rxSer = inject(RxTransferService);

 isDrugSearchopen: boolean = false;
 searchHistory: boolean = false;
  constructor(private _cdr: ChangeDetectorRef, 
    private _commonSvc: CommonService,
    private _commonUtil:CommonUtil,
    private _modalService: ModalWrapperService,
    private _patPreDrugService: PatPreDrugModalService,
    public _formatsUtil:FormatsUtil) { }

  ngOnInit(): void {
    if(this.DefaultTransferType) {
        this.eRxModelFG.controls['transferType'].patchValue(this.DefaultTransferType)
    } else {
      this.DefaultTransferType = this.eRxModelFG?.value['transferType'];
    }
    if(this.RequestedInfo) // if RequestedInfo available fields should be disabled
        if(this.RequestedInfo){
          this.DefaultTransferType = this.eRxModelFG.value['transferType'];
            this.eRxModelFG.controls['transferType'].disable();
        }
        if(this.IsPush) {
           this.eRxModelFG.controls['transferType'].patchValue(1); // For push 
        }
  }
  
  getPatientInformation(patInfo) {
      const previousPatientId = this.previousPatientId;
      const currentPatientId = patInfo?.patientid;
      const isPatientChanged = !!(previousPatientId && currentPatientId && previousPatientId !== currentPatientId);
      if (isPatientChanged) {
        // Clear stale patient-history selections so old patient Rxs are not emitted.
        this.transferRxInfo = [];
        this.selectedRxs = [];
        this.transferInRxsCopy = [];
        this.TransferRxsList.emit([]);
      }
      this.eRxPatient = patInfo;
      this.previousPatientId = currentPatientId;
  }

  openDrugSearchpopup(type?) {
    this.selectedDeatils =  null;
    this._cdr.detectChanges();
    this.selectedDeatils = type ? type :  null;
    if(type && type === "Drug" && !this.isDrugSearchopen && (!this.eRxModelFG.value['drugItem'] || !(typeof this.eRxModelFG.value['drugItem'] === 'object'))) {
        this.isDrugSearchopen = false;
        this._cdr.detectChanges();
        this.isDrugSearchopen = true;
    } else if(type && type === "DrugIcon") {
      this.isDrugSearchopen = false;
      this._cdr.detectChanges();
      this.isDrugSearchopen = true;
    } else if(type && type === "history") {
       if(this.eRxModelFG.value['patientInfo']) {  // If patient is selected Already
           this.eRxPatient = this.eRxModelFG.value['patientInfo'];
       }
     this.routeToPatientHistory();
    }
    if(type !== "history")
    {
      this.DefaultTransferType =  type === 'All' ? 3 : 2;
      this.SelectedTransType.emit(type);
    this.SelectedDrugDetails.emit(type === "Drug" && this.eRxModelFG.value['drugID'] ? this.eRxModelFG.value['drugItem'] : null);
    }
  }
  routeToPatientHistory() {
    this.isInputFocused = true;
         if(!this.modalRef2) { 
           this.modalRef2 = this._modalService.open(this.SelectRxsFromPatHistory, {
            keyboard: false,
            size: "lg",
            windowClass: "max-modal-lg-size",
            centered : true
        });
         }
      }

      ngOnChanges() {
   }

   closeDrugResultModaIcon(event) {
        this.isDrugSearchopen = false;
        if(!this.RequestedInfo)
        {
          this.eRxModelFG.controls['transferType'].patchValue((this.eRxModelFG.value['drugItem'] && this.eRxModelFG.value['drugItem'] !== 'All') ? "2" :  "3");
          this.DefaultTransferType = this.eRxModelFG.value['transferType'];
        }
       if(this.DefaultTransferType == 3)
          this.eRxModelFG.controls['IsTransferIn'].patchValue(true);
        else if(!this.RequestedInfo) {
          this.eRxModelFG.controls['drugID'].patchValue(null);
          this.SetTransferType.emit(this.eRxModelFG.value['drugItem']);
          this.SelectedDrugDetails.emit(this.eRxModelFG.value['drugItem'] ? this.eRxModelFG.value['drugItem'] : 'All'); 
        } else if(this.RequestedInfo) {
                this.eRxModelFG.controls['transferType'].patchValue(this.RequestedInfo && this.RequestedInfo?.Drug?.result ? "2" :  "3");
        }
   }
   
  selectedDrug(drug) {
    this.SelectedDrugDetails.emit(drug);
    this.SelectedTransType.emit(null);
  }

   selectdCancelPat(patientInfo:any) {
        this.eRxPatient = patientInfo;
        if(patientInfo)
          (patientInfo as any).IsFromNotHistory = true;
       this.ReSelectPatient.emit(patientInfo);
    }

  getRxInfo(rxs) {
    this.closeModal2(true);
      this.transferRxInfo = [...this.transferRxInfo, ...rxs];
      this.TransferRxsList.emit([...this.transferRxInfo]);
  }

  closeModal2(IsFrmHtml?: boolean) {
    if(!IsFrmHtml) {
      this.transferRxInfo = this.transferInRxsCopy;
    }
    this.isInputFocused = false;
    if (this.modalRef2) {
      this.modalRef2.close();
      this.modalRef2 = null;
    }
  }

  pickTransferlRxs() {
    this.closeModal2();
    this.transferRxInfo =  [...this.selectedRxs];  
    this.TransferRxsList.emit([...this.transferRxInfo]);
  }

  resetCancelPatient() {
        this.eRxPatient = null;
        this.isInputFocused = false;
        setTimeout(() => {
            this.isInputFocused = true;
        }, 30);
    }

}
